import { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';

export function PricingToggle() {
  const [isAnnual, setIsAnnual] = useState(true);
  const discount = 20;

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="inline-flex items-center rounded-full border border-indigo-100 bg-white p-1">
        <Button
          variant={isAnnual ? 'secondary' : 'ghost'}
          size="sm"
          onClick={() => setIsAnnual(true)}
          className="rounded-full px-6"
        >
          Annual
        </Button>
        <Button
          variant={!isAnnual ? 'secondary' : 'ghost'}
          size="sm"
          onClick={() => setIsAnnual(false)}
          className="rounded-full px-6"
        >
          Monthly
        </Button>
      </div>
      {isAnnual && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center rounded-full bg-gradient-to-r from-indigo-500/10 to-purple-500/10 px-4 py-1"
        >
          <span className="text-sm font-medium text-indigo-600">
            Save {discount}% with annual billing
          </span>
        </motion.div>
      )}
    </div>
  );
}